import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle, setHeaderAction, setActionBtnTitle } from 'features/ui/model/uiSlice';
import { PrizesTable, DrawerPrizes } from 'widgets/prize';

import { CreatePrizeForm } from 'entities/prize';

export const PrizesPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Призы'));
    dispatch(setHeaderAction('create'));
    dispatch(setActionBtnTitle('Создать'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return (
    <>
      <PrizesTable />
      <DrawerPrizes>
        <CreatePrizeForm />
      </DrawerPrizes>
    </>
  );
};
